import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { NgClinicalFeesModule } from '@principle-theorem/ng-clinical-fees';
import { NgPatientModule } from '@principle-theorem/ng-patient';
import { ExternalLinkRedirectComponent } from '../external-link/external-link-redirect/external-link-redirect.component';
import { BrandResolverService } from '../layout/brand-resolver.service';
import { PracticeResolverService } from '../layout/practice-resolver.service';
import { APP_ROUTES } from './app-routes';

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always',
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
    NgClinicalFeesModule,
    NgPatientModule,
    ExternalLinkRedirectComponent,
  ],
  providers: [PracticeResolverService, BrandResolverService],
  exports: [RouterModule],
})
export class AppRoutingModule {}
